export default "__VITE_ASSET__BusoQ7WR__"